export enum ESupplierStatus {
    ACTIVE = 1,
    INACTIVE = 2
}

export enum ESupplierType {
    NATURAL = 'natural',
    BUSINESS = 'business'
}
